import { ApiClientError, TacticApiClient } from '@gettactic/api';

export const cancelOfficeSettings = async (
  api: TacticApiClient,
  id: string,
  onSuccess: () => void,
  onError: () => void
) => {
  try {
    const data =
      await api.client.orgOrOfficeSettings.cancelCustomOfficeHours(id);
    if (data.ok) {
      onSuccess();
      // nothing is returned from BE
      return;
    }

    console.error('Error cancelling office settings', data);
    onError();
    return;
  } catch (error) {
    if (error instanceof ApiClientError) {
      // we consider it a success if the office settings are not found
      // upon deletion, the BE returns a 404
      // remove this sorcery when api is updated
      if (error?.response?.status === 404) {
        onSuccess();
        return;
      }
    }
    onError();
    throw error;
  }
};
